module.exports = __webpack_public_path__ + "static/media/PSE.33859068.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/PSE.png
// module id = 1991
// module chunks = 0